export default __webpack_public_path__ + "static/logo-transparent-2e7b22ac33b4ef2ad569d91cd8f89d50.svg";